import React from 'react';
import { CenteredContent, TwoColumns, TwoSectionBG } from '../Section/index';
import { NextSessions, IntraCompany } from './index';
import sizes from 'src/style/sizes';
import colors from 'src/style/colors';
import { useMediaQueries } from '../../utils/MediaQueries';

const ProNextSessionsIntraCompany = ({
  isSessionName,
  nextSession,
  sessionPrice,
  formationName,
}) => {
  const mqs = useMediaQueries();

  return (
    <div>
      {mqs.tabletLandscapeUp ? (
        <div
          css={{
            position: 'relative',
          }}
        >
          <TwoSectionBG
            isSessionName={isSessionName}
            colorLeft={colors.purple}
            colorRight={colors.yellow}
          />

          <CenteredContent css={{ zIndex: 2, position: 'relative' }}>
            {isSessionName && (
              <TwoColumns
                withoutSpace
                sizeLeft={sizes.columnWidth.medium}
                left={
                  <NextSessions
                    nextSession={nextSession}
                    isSessionName={isSessionName}
                    sessionPrice={sessionPrice}
                    withoutCenteredContent
                  />
                }
                sizeRight={sizes.columnWidth.medium}
                right={
                  <IntraCompany
                    withoutCenteredContent
                    isSessionName={isSessionName}
                    formationName={formationName}
                  />
                }
              />
            )}

            {isSessionName ? null : (
              <IntraCompany
                withoutCenteredContent
                isSessionName={isSessionName}
                formationName={formationName}
              />
            )}
          </CenteredContent>
        </div>
      ) : (
        <div>
          {isSessionName && (
            <NextSessions
              nextSession={nextSession}
              isSessionName={isSessionName}
              sessionPrice={sessionPrice}
            />
          )}
          <IntraCompany formationName={formationName} />
        </div>
      )}
    </div>
  );
};

export default ProNextSessionsIntraCompany;
